import { API_PREFIX, CaseId } from '../types';
import getAll from './getAll';
import create from './create';
import update from './update';
import deleteVulnerability from './delete';
import { VulnerabilityId } from './Vulnerability';
import { FormVulnerbaility } from 'modules/cm/pages/CaseDetailsPage/subPages/Applicant/Vulnerabilities/Vulnerability';

const indexFunc = (caseId: CaseId) => (applicantId: number) => ({
  getAll: () => getAll(`${API_PREFIX}/${caseId}/applicant/${applicantId}`),
  create: (vulnerability: FormVulnerbaility) =>
    create(`${API_PREFIX}/${caseId}/applicant/${applicantId}`, vulnerability),
  update: (id: VulnerabilityId, vulnerability: FormVulnerbaility) =>
    update(`${API_PREFIX}/${caseId}/applicant/${applicantId}`, id, vulnerability),
  deleteVulnerability: (vulnerabilityId: VulnerabilityId) =>
    deleteVulnerability(`${API_PREFIX}/${caseId}/applicant/${applicantId}`, vulnerabilityId),
});
export default indexFunc;
